import useTenantFeatures from './useTenantFeatures';
import usePlanControl from './usePlanControl';

// THE THREE AI QUESTIONS A VISIT SCREEN ASKS (owner, 2 Oct 2026). Each one is
// the hospital's switch (tenant feature — fails open) AND the signed-in
// doctor's plan control (usePlanControl — always true for anyone but a doctor):
//
//   audioTranscription      ai_transcription             the prescription audio
//                                                         notes (clips on a visit)
//   recordingTranscription  ai_recording_transcription   the transcript of a
//                                                         recorded video visit
//   summary                 ai_summary + plan ai_appointment_summary
//                                                         the visit's AI summary
//
// They decide only what is DRAWN while something is still to come: off means
// no "Generating…" spinner and no poll. The audio upload itself is offered
// either way (the clip is stored and playable without a transcript), and a
// transcript or summary already stored is always shown. The server decides;
// this is the courtesy half.
export default function useVisitAiGates() {
    const { has } = useTenantFeatures();
    const audioPlan = usePlanControl('ai_transcription');
    const recordingPlan = usePlanControl('ai_recording_transcription');
    const summaryPlan = usePlanControl('ai_appointment_summary');
    return {
        audioTranscription: has('ai_transcription') && audioPlan,
        recordingTranscription: has('ai_recording_transcription') && recordingPlan,
        summary: has('ai_summary') && summaryPlan,
    };
}
